import { Grid } from '@mui/material';
import { handleOpenedOverlay } from 'App/utils';
import { ButtonAppearance, Button, Dialog } from 'components';
import { ReactNode, useEffect } from 'react';
import { useLocation } from 'react-router-dom';

type CloseModalProps = {
  isOpen: boolean;
  onClose: () => void;
  onCancel?: () => void;
  content: ReactNode;
  successButtonText: string;
  cancelButtonText?: string;
  slug: string;
};

export const Modal = ({
  isOpen,
  onClose,
  onCancel,
  content,
  successButtonText,
  cancelButtonText,
  slug,
}: CloseModalProps) => {
  const location = useLocation();
  useEffect(() => {
    if (isOpen) handleOpenedOverlay(slug, location.pathname);
  }, [isOpen, slug, location.pathname]);
  return (
    <Dialog slug={slug} content={content} isOpen={isOpen} onClose={onClose}>
      <Grid container justifyContent='center' spacing={2}>
        <Grid item justifyContent='flex-end'>
          <Button appearance={ButtonAppearance.PRIMARY} isSmall onClick={() => onClose()} text={successButtonText} />
        </Grid>
        {cancelButtonText && (
          <Grid item justifyContent='flex-start'>
            <Button isSmall appearance={ButtonAppearance.SECONDARY} onClick={onCancel} text={cancelButtonText} />
          </Grid>
        )}
      </Grid>
    </Dialog>
  );
};
